import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'primary' | 'ghost' | 'ok' | 'danger'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: 'md' | 'sm'
  children: ReactNode
}

const map: Record<Variant, string> = {
  primary: 'btn-primary',
  ghost: 'btn-ghost',
  ok: 'btn-ok',
  danger: 'btn-danger'
}

export function Button({
  variant = 'ghost',
  size = 'md',
  className = '',
  type = 'button',
  children,
  ...rest
}: Props) {
  return (
    <button
      type={type}
      className={`btn ${map[variant]} ${size === 'sm' ? 'btn-sm' : ''} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  )
}
